<template>
<div>
    <h1 class="mb-4 text-gray-500">Onlyfans Downloader</h1>
    <client-only>
        <template #fallback>
            <el-card shadow="never" :body-style="{padding: '0'}" class="mb-4">
                <div style="height: 100px" class="flex items-center justify-center">
                    <ElIconLoading :width="20" class="mr-2"/>
                    Loading the app
                </div>
            </el-card>
        </template>
        <downloader></downloader>
    </client-only>
    <el-card shadow="never" class="mb-4" :body-style="{ padding: '20px' }">
        <h2 class="text-2xl mb-4">
            Demo video
        </h2>
        <div class="mb-4"> Learn how to get started with onlyfans downloader by watching the demo video </div>
        <el-button type="info" size="large" :icon="ElIconVideoPlay" @click="showDemoVideo = true" v-if="!showDemoVideo">Watch video</el-button>

        <video controls autoplay="false" v-show="showDemoVideo">
            <source src="https://anyloader.com/onlyfans_downloader_demo.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </el-card>
    <onlyfans-faq></onlyfans-faq>
</div>
</template>
<script>
export default {
    created() {
        const siteUrl = useRuntimeConfig().public.siteUrl
        const faqStructuredData = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
                {
                    '@type': 'Question',
                    name: 'What is Anyloader?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'The Anyloader is a software designed to allow users to download content from websites like OnlyFans, from posts, profiles and chats for offline viewing.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'How does the app work?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'The app requires a chrome extension to be installed and communicates with the chrome extension to find and download the media content associated with the given link.'
                    }
                },
                {
                    '@type': 'Question',
                    name: 'Can I download media from paid subscription based onlyfans accounts?',
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: 'Yes, you can if you are subscribed to the account.'
                    }
                }
            ]
        }

        useHead({
            title: 'Free OnlyFans Downloader - Download Videos & Photos from OnlyFans',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Download videos and photos from OnlyFans for free using our Chrome extension. Save content from posts, profiles & chats for offline viewing. Works with subscribed accounts.',
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: 'onlyfans downloader, download onlyfans videos, onlyfans video downloader, free onlyfans downloader, onlyfans chrome extension, onlyfans bulk download'
                }
            ],
            link: [
                {rel: 'canonical', href: siteUrl + '/onlyfans-downloader'}
            ],
            script: [
                {
                    type: 'application/ld+json',
                    children: JSON.stringify(faqStructuredData)
                }
            ]
        })
    },
    data () {
        return {
            showDemoVideo: false
        }
    }
}
</script>
